const options = {
  vuex: {
    namespace: 'storage'
  },
  cookie: false,
  localStorage: {
    prefix: ''
  },
  ignoreExceptions: false
}

// Nuxt globally
export default options
